var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiGlyph = function SvgAiGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7418 5.66186C8.10131 4.65631 7.34378 3.89876 6.339 0.258159C6.29668 0.105803 6.15787 0 6.00043 0C5.84215 0 5.70418 0.105803 5.66186 0.258159C4.65631 3.89869 3.89876 4.65622 0.25816 5.66186C0.105804 5.70418 0 5.843 0 6.00043C0 6.15872 0.105804 6.29669 0.25816 6.339C3.89869 7.34456 4.65622 8.10126 5.66186 11.7418C5.70418 11.8942 5.843 12 6.00043 12C6.15872 12 6.29669 11.8942 6.339 11.7418C7.34456 8.10131 8.10126 7.34378 11.7418 6.339C11.8942 6.29668 12 6.15787 12 6.00043C12 5.84215 11.8942 5.70418 11.7418 5.66186Z",
    fill: "currentColor"
  })));
};
export default SvgAiGlyph;